<template>
  <div class="wrapCodeViewer">
    <div @click="$emit('copy')" class="overlay"></div>

    <v-btn icon @click="$emit('copy')" class="controllerCopy">
      <v-icon>action_copy</v-icon>
    </v-btn>

    <pre class="json">
      <code class="json">
        <span class="symbol s-1">{</span>
        <span class="key s-2">"Version"</span>: <span class="string">"2012-10-17"</span>,
        <span class="key s-2">"Statement"</span>: <span class="symbol">[</span>
            <span class="symbol s-3">{</span>
            <span class="key s-4">"Sid"</span>: <span class="string">"VizNowManage0"</span>,
            <span class="key s-4">"Effect"</span>: <span class="string">"Allow"</span>,
            <span class="key s-4">"Action"</span>: <span class="symbol">[</span>
                <span class="string s-5">"iam:*",</span>
                <span class="string s-5">"kms:*",</span>
                <span class="string s-5">"route53:*",</span>
                <span class="string s-5">"servicequotas:*",</span>
                <span class="string s-5">"s3:*",</span>
                <span class="string s-5">"ec2:*",</span>
                <span class="string s-5">"tag:*",</span>
                <span class="string s-5">"sts:*",</span>
                <span class="string s-5">"logs:*"</span>
            <span class="symbol s-4">]</span>,
            <span class="key s-4">"Resource"</span>: <span class="string">"*"</span>
            <span class="symbol s-3">},</span>
            <span class="symbol s-3">{</span>
            <span class="key s-4">"Sid"</span>: <span class="string">"AllowSSMDocumentsForSendCommand"</span>,
            <span class="key s-4">"Effect"</span>: <span class="string">"Allow"</span>,
            <span class="key s-4">"Action"</span>: <span class="string">"ssm:SendCommand"</span>,
            <span class="key s-4">"Resource"</span>: <span class="string">"arn:aws:ssm:*:*:document/*"</span>
            <span class="symbol s-3">},</span>
            <span class="symbol s-3">{</span>
            <span class="key s-4">"Sid"</span>: <span class="string">"AllowSendCommandToVizNowInstances"</span>,
            <span class="key s-4">"Effect"</span>: <span class="string">"Allow"</span>,
            <span class="key s-4">"Action"</span>: <span class="symbol">[</span><span class="string">"ssm:SendCommand"</span><span class="symbol">]</span>,
            <span class="key s-4">"Resource"</span>: <span class="string">"arn:aws:ec2:*:*:instance/*"</span>,
            <span class="key s-4">"Condition"</span>: <span class="symbol">{</span>
                <span class="key s-5">"StringEquals"</span>: <span class="symbol">{</span>
                    <span class="key s-6">"ssm:ResourceTag/VizNow"</span>: <span class="string">"true"</span>
                <span class="symbol s-5">}</span>
            <span class="symbol s-4">}</span>
            <span class="symbol s-3">},</span>
            <span class="symbol s-3">{</span>
            <span class="key s-4">"Sid"</span>: <span class="string">"AllowCommandInvocationChecks"</span>,
            <span class="key s-4">"Effect"</span>: <span class="string">"Allow"</span>,
            <span class="key s-4">"Action"</span>: <span class="symbol">[</span>
                <span class="string s-5">"ssm:ListCommandInvocations"</span>,
                <span class="string s-5">"ssm:GetCommandInvocation"</span>
            <span class="symbol s-4">]</span>,
            <span class="key s-4">"Resource"</span>: <span class="string">"*"</span>
            <span class="symbol s-3">},</span>
            <span class="symbol s-3">{</span>
            <span class="key s-4">"Sid"</span>: <span class="string">"AllowSSMInventoryReadOnly"</span>,
            <span class="key s-4">"Effect"</span>: <span class="string">"Allow"</span>,
            <span class="key s-4">"Action"</span>: <span class="symbol">[</span>
                <span class="string s-5">"ssm:ListInventoryEntries"</span>,
                <span class="string s-5">"ssm:DescribeInstanceInformation"</span>
            <span class="symbol s-4">]</span>,
            <span class="key s-4">"Resource"</span>: <span class="string">"*"</span>,
            <span class="key s-4">"Condition"</span>: <span class="symbol">{</span>
                <span class="key s-5">"StringEquals"</span>: <span class="symbol">{</span>
                    <span class="key s-6">"ssm:ResourceTag/VizNow"</span>: <span class="string">"true"</span>
                <span class="symbol s-5">}</span>
            <span class="symbol s-4">}</span>
            <span class="symbol s-3">},</span>
            <span class="symbol s-3">{</span>
            <span class="key s-4">"Sid"</span>: <span class="string">"AllowCreateMediaConnectFlows"</span>,
            <span class="key s-4">"Effect"</span>: <span class="string">"Allow"</span>,
            <span class="key s-4">"Action"</span>: <span class="symbol">[</span><span class="string">"mediaconnect:CreateFlow"</span><span class="symbol">]</span>,
            <span class="key s-4">"Resource"</span>: <span class="string">"*"</span>
            <span class="symbol s-3">},</span>
            <span class="symbol s-3">{</span>
            <span class="key s-4">"Sid"</span>: <span class="string">"AllowManageVizNowFlowsByName"</span>,
            <span class="key s-4">"Effect"</span>: <span class="string">"Allow"</span>,
            <span class="key s-4">"Action"</span>: <span class="symbol">[</span>
                <span class="string s-5">"mediaconnect:DeleteFlow",</span>
                <span class="string s-5">"mediaconnect:UpdateFlow",</span>
                <span class="string s-5">"mediaconnect:StartFlow",</span>
                <span class="string s-5">"mediaconnect:StopFlow",</span>
                <span class="string s-5">"mediaconnect:AddFlowOutputs",</span>
                <span class="string s-5">"mediaconnect:RemoveFlowOutput",</span>
                <span class="string s-5">"mediaconnect:UpdateFlowOutput",</span>
                <span class="string s-5">"mediaconnect:AddFlowSources",</span>
                <span class="string s-5">"mediaconnect:RemoveFlowSource",</span>
                <span class="string s-5">"mediaconnect:UpdateFlowSource",</span>
                <span class="string s-5">"mediaconnect:AddFlowVpcInterfaces",</span>
                <span class="string s-5">"mediaconnect:RemoveFlowVpcInterface",</span>
                <span class="string s-5">"mediaconnect:GrantFlowEntitlements",</span>
                <span class="string s-5">"mediaconnect:UpdateFlowEntitlement",</span>
                <span class="string s-5">"mediaconnect:DescribeFlow",</span>
                <span class="string s-5">"mediaconnect:ListEntitlements"</span>
            <span class="symbol s-4">]</span>,
            <span class="key s-4">"Resource"</span>: <span class="string">"arn:aws:mediaconnect:*:*:*VizNow-*"</span>
            <span class="symbol s-3">},</span>
            <span class="symbol s-3">{</span>
            <span class="key s-4">"Sid"</span>: <span class="string">"AllowListMediaConnectFlows"</span>,
            <span class="key s-4">"Effect"</span>: <span class="string">"Allow"</span>,
            <span class="key s-4">"Action"</span>: <span class="symbol">[</span>
                <span class="string s-5">"mediaconnect:ListFlows",</span>
                <span class="string s-5">"mediaconnect:DescribeFlow",</span>
                <span class="string s-5">"mediaconnect:ListTagsForResource"</span>
            <span class="symbol s-4">]</span>,
            <span class="key s-4">"Resource"</span>: <span class="string">"*"</span>
            <span class="symbol s-3">}</span>
        <span class="symbol s-2">]</span>
        <span class="symbol s-1">}</span>
      </code>
    </pre>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api"

export default defineComponent({
  name: "CodeSnippet"
})
</script>
